import { AppThunk } from '@/store'
import { createAction, request } from '@/store/actions'

import * as types from './actionTypes'

export function saveQuestionSet(questionSet: any): AppThunk {
  return dispatch => {
    dispatch(
      createAction(types.SAVE_QUESTION_SET, {
        questionSet
      })
    )
  }
}
export function resetQuestionSet(): AppThunk {
  return dispatch => {
    dispatch(createAction(types.RESET_QUESTION_SET))
  }
}

export function saveDraftQuestionSet(body: any, service = 'knowledgeV2'): AppThunk {
  const method = body?.id ? 'PUT' : 'POST'
  return dispatch => {
    return dispatch(
      request(
        '/space/:spaceId/questionsets/save',
        types.SAVE_DRAFT_QUESTION_SET,
        { method, body: { ...body, status: 'pending-create' } },
        { service }
      )
    )
  }
}

export function savePublishQuestionSet(questionSet: any, service = 'knowledge'): AppThunk {
  const method = questionSet?.id ? 'PUT' : 'POST'
  return dispatch => {
    return dispatch(
      request(
        '/space/:spaceId/questionsets/save/publish',
        types.SAVE_PUBLISH_QUESTION_SET,
        { method, body: questionSet },
        { service }
      )
    )
  }
}

export function fetchKnowledgeQuestionSets(
  {
    noLoader
  }: {
    noLoader?: boolean
  },
  service = 'knowledgeV2'
): AppThunk {
  return dispatch => {
    return dispatch(
      request(
        `/space/:spaceId/questionsets`,
        noLoader ? types.FETCH_KNOWLEDGE_QUESTION_SETS_NO_LOADER : types.FETCH_KNOWLEDGE_QUESTION_SETS,
        {},
        { service }
      )
    )
  }
}

export function clearCreatedQuestionSet() {
  return {
    type: types.CLEAR_CREATED_QUESTION_SET
  }
}
